export const appsAppGroupIdUninstallTrackingApps = "/apps/:app_group_id/uninstall_tracking_apps";
